import { render, staticRenderFns } from "./UploadWholesaleModal.vue?vue&type=template&id=01939c89&scoped=true&"
import script from "./UploadWholesaleModal.vue?vue&type=script&lang=js&"
export * from "./UploadWholesaleModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadWholesaleModal.vue?vue&type=style&index=0&id=01939c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01939c89",
  null
  
)

export default component.exports